export { default } from "./SignUpLogInCta";
